import NextLiveCountdownBlock from './NextLiveCountdownBlock';

export default NextLiveCountdownBlock;
